export const DMS_MODULE = 'Accounting';
export const NAME = 'Accounting';
export const ACCOUNT_UNSETTLEMENT_VALUE = 'Non Settled';
export const ACCOUNT_SETTLEMENT_VALUE = 'Settled';
